// Module
var code = "<a href=\"#\"> <i class=\"fa transition fa-play run-query-icon\"></i> <!-- ko text: _labels.RUN_QUERY --><!-- /ko --> </a>";
// Exports
export default code;